import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import './styles.scss'

import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useActions, useValues } from 'kea'
import Modal from 'react-responsive-modal'

import useModalHistory from 'lib/utils/use-modal-history'

import ClassCarousel from './class-carousel'

import lightboxLogic from './logic'

const Lightbox = ({ user }) => {
  const logic = lightboxLogic({ user })

  const { isLightboxOpen, lightBoxPhotos, currentImage, currentImageNumber } = useValues(logic)

  const { setCurrentImage, closeLightBox, setDimensions } = useActions(logic)

  useModalHistory(isLightboxOpen, closeLightBox, 'lightbox-modal')

  const updateDimensions = useCallback(() => {
    setDimensions(window.innerWidth, window.innerHeight)
  }, [setDimensions])

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    updateDimensions()

    return () => {
      window.removeEventListener('resize', updateDimensions)
    }
  }, [updateDimensions])

  return (
    <Modal
      open={isLightboxOpen}
      showCloseIcon={false}
      center
      closeOnEsc
      focusTrapped={false}
      blockScroll={false}
      classNames={{
        overlay: 'lightbox-overlay',
        modal: 'lightbox-modal'
      }}
    >
      <ClassCarousel
        lightBoxPhotos={lightBoxPhotos}
        currentImage={currentImage}
        setCurrentImage={setCurrentImage}
        isLightboxOpen={isLightboxOpen}
        currentImageNumber={currentImageNumber}
        closeLightBox={closeLightBox}
      />
    </Modal>
  )
}

Lightbox.propTypes = {
  user: PropTypes.object.isRequired
}

export default Lightbox
